import axios from 'axios'

function createQueryString(parameters) {
    if (Object.keys(parameters)) {
        return Object.entries(parameters)
            .map((param) => param.join('='))
            .join('&')
    }

    return false
}

function prepareUrl(url, parameters) {
    if (typeof parameters !== 'undefined') {
        if (Object.keys(parameters).length) {
            return `${url}?${createQueryString(parameters)}`
        }
    }

    return url
}

export default class ApiService {
    /**
     * Axios http object.
     *
     * @var {axios}
     */
    http

    /**
     * ApiService constructor.
     *
     * @constructor
     *
     * @param {String} baseUrl
     * @param {Object} parameters
     * @param {Object} headers
     * @param {Object} options
     *
     * @returns {void}
     */
    constructor(base, parameters = {}, headers = {}, options = {}) {
        const defaultHeaders = {
            Accept: 'application/json',
            'Content-Type': 'application/json',
        }

        this.http = axios.create(Object.assign(options, {
            headers: Object.assign(defaultHeaders, headers),
            baseURL: base,
            params: parameters,
        }))
    }

    /**
     * Enable Auth headers.
     *
     * @returns {void}
     */
    enableAuth() {
        this.http.defaults.withCredentials = true
        this.http.defaults.headers.common['Content-Type'] = 'application/json'
        this.http.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest'
    }

    /**
     * Set API Key.
     *
     * @param {String} apiKey
     *
     * @returns {Self}
     */
    setApiKey(key) {
        this.http.defaults.headers.common['X-API-KEY'] = key

        return this
    }

    /**
     * Set Access token.
     *
     * @param {String} token
     *
     * @returns {Self}
     */
    setAccessToken(token) {
        // eslint-disable-next-line
        this.http.defaults.headers.common['Authorization'] = `Bearer ${token}`;

        return this
    }

    /**
     * Set Accept Language header.
     *
     * @param {String} header
     *
     * @returns {Self}
     */
    setAcceptLanguage(header) {
        this.http.defaults.headers.common['Accept-Language'] = header

        return this
    }

    /**
     * Axios post request.
     *
     * @param {String} url
     * @param {Object} parameters
     *
     * @returns {Promise}
     */
    get(baseUrl, parameters) {
        return new Promise((resolve, reject) => {
            const url = prepareUrl(baseUrl, parameters)

            this.http
                .get(url)
                .then((response) => {
                    resolve(response)
                })
                .catch((error) => {
                    reject(error)
                })
        })
    }

    /**
     * Axios post request.
     *
     * @param {String} url
     * @param {Object} parameters
     * @param {Object} config
     *
     * @returns {Promise}
     */
    post(url, parameters, config = {}) {
        return new Promise((resolve, reject) => {
            this.http
                .post(url, parameters, config)
                .then((response) => {
                    resolve(response)
                })
                .catch((error) => {
                    reject(error)
                })
        })
    }

    /**
     * Proxy to Axios patch request
     *
     * @param {string} url
     * @param {Object} parameters
     * @param {Object} config
     *
     * @returns {Promise}
     */
    async patch(url, parameters, config = {}) {
        return new Promise((resolve, reject) => {
            this.http
                .patch(url, parameters, config)
                .then((response) => resolve(response))
                .catch((error) => reject(error))
        })
    }
}
